<script setup lang="ts">
import { isFilled } from '@prismicio/client'
import type { Content } from "@prismicio/client";

const props = defineProps(getSliceComponentProps<Content.QuoteCtaSlice>());

const settings = useSettings()

const title = computed(() =>
  isFilled.richText(props.slice.primary.title)
    ? props.slice.primary.title
    : settings.value?.data.default_quote_title
)

const description = computed(() =>
  isFilled.richText(props.slice.primary.description)
    ? props.slice.primary.description
    : settings.value?.data.default_quote_description
)
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-bounded','pa-qcta', { 'pa-qcta--above-footer': slice.variation === 'aboveFooter' }]"
  >
    <div class="pa-qcta__bg">
      <div class="pa-container">
        <div class="pa-qcta__card">
          <div class="pa-qcta__image">
            <PrismicImage
                v-if="slice.primary.image?.url"
                :field="slice.primary.image"
            />
          </div>
          <div class="pa-qcta__content">
            <div class="pa-qcta__content-title">
              <PrismicRichText :field="title" />
            </div>
            <div class="pa-qcta__content-description">
              <PrismicRichText :field="description" />
            </div>
            <div v-if="slice.primary.cta_link && ('id' in slice.primary.cta_link || 'url' in slice.primary.cta_link)">
              <TrackedPrismicLink
                  :field="slice.primary.cta_link"
                  :track="slice.primary.cta_track_event"
                  class="pa-btn pa-btn--secondary"
              >
                {{ slice.primary.cta_link.text || "Meer info" }}
                <span aria-hidden="true">&rarr;</span>
              </TrackedPrismicLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
